import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpUtilsService } from '../../_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import * as jwt_decode from 'jwt-decode';
const API_ROOT_URL = environment.ApiRoot + '/user';

@Injectable()
export class UserProfileService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

    checkPhienDangNhap(): Observable<any> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<any>(API_ROOT_URL + '/CheckTimeSession', null, { headers: httpHeaders });
    }

    // Check session
    dangXuatHeThong(): Observable<any> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<any>(API_ROOT_URL + '/LogOut', { headers: httpHeaders });
    }

    isPermission(item: any): Observable<any> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<any>(environment.ApiRoot + `/UserNFC/PermissionUrl?currentUrl=${item}`, { headers: httpHeaders });
    }

    getCoCauId(): Observable<any> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<any>(environment.ApiRoot + `/UserNFC/GetCoCauToChuc`,null ,{ headers: httpHeaders });
    }

}